// extracted by mini-css-extract-plugin
module.exports = {"mobile":"_1G_f5","root":"_3hEZL","onImage":"XmIaS"};